export default (props) => {
	switch (props.decorator || props.is) {
		case 'WebLayout':
			return import('./components/WebLayout');
		case 'RadioSelect':
		case 'CheckboxSelect':
			return import('fg-frontend/src/components/RadioSelect');
		case 'AlertBox':
			return import('fg-frontend/src/components/AlertBox');
		case 'NumberInput':
			return import('fg-frontend/components/NumberInput');
		case 'Typeahead':
			return import('./components/Typeahead');
		case 'AddSvgIconSprite':
			return import('./components/AddSvgIconSprite');
		case 'Tooltip':
			return import('./components/Tooltip');
		case 'GtmMHubHandler':
			return import('./components/GtmMHubHandler/GtmMHubHandler');
		case 'TransformerTabs':
			return import('./components/TransformerTabs');
		case 'ModalWindow':
			return import('./components/ModalWindow');
		case 'KoopDatepicker':
			return import('./components/KoopDatepicker');
		case 'Submitter':
			return import('./components/Submitter');
		case 'KoopForm':
			return import('./components/KoopForm');
		case 'PrintPage':
			return import('./components/PrintPage');
		case 'PaymentLoader':
			return import('./components/PaymentLoader');
		case 'Preloader':
			return import('./components/preloader/Preloader');
		case 'Realty':
			return import('./components/Realty');
		case 'FloorAreasHouse':
			return import('./components/FloorAreasHouse');
		case 'ButtonHider':
			return import('./components/ButtonHider');
		case 'GarageInsurance':
			return import('./components/GarageInsurance');
		case 'Callback':
			return import('./components/Callback');
		case 'WeWillCallYou':
			return import('./components/WeWillCallYou');
		case 'Package':
			return import('./components/Package');
		case 'ScrollToTargetAfterLoad':
			return import('./components/ScrollToTargetAfterLoad');
		default:
			console.log(`Unknown component ${ props.decorator || props.is }`);
			return null;
	}
};



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/configureWebComponents.js